import React from 'react';
import Autosuggest from "react-autosuggest";
import '../../style/dots.css';
import '../../style/solicitorGroupList.css'
import SolicitorGroupHOC from '../../containers/SolicitorGroups/solicitorGroupHOC'
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import {LEGAL_ADVICE_TEXT, TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import CustomTable from "../General/customTable/CustomTable";
import CustomModal from "../General/customModal";

const columns = [
    {propertyName: "name", header: "Name"},
    {
        propertyName: "underwriterName",
        header: "Capacity Underwriter",
        formatter: (row) => (
            <ul className={"ul-with-bullets"}>
                {
                    row.underwriterNames.map((uw, index) => {
                        return <li key={index}>
                            {uw}
                        </li>
                    })
                }
            </ul>
        )
    },
    {propertyName: "solicitors", header: `${LEGAL_ADVICE_TEXT}s`, formatter: (datum) => (
            <ul className={"ul-with-bullets"}>
                {
                    datum.solicitors.map((solicitor, index) => {
                        return <li key={index}>
                            {solicitor.lawsysFirm}
                        </li>
                    })
                }
            </ul>
        )},
    {propertyName: "workSources", header: "Work Sources", formatter: (datum) => (
            <ul className={"ul-with-bullets"}>
                {
                    datum.workSourceNames.map((workSource, index) => {
                        return <li key={index}>
                            {workSource}
                        </li>
                    })
                }
            </ul>
        )}
];

const SolicitorGroupList = (props) => {
    let calcOffset =props.store.selectedView*(props.store.page -1);
    let parameters = {
        limit: props.store.selectedView,
        offset: calcOffset>0? calcOffset:0,
        search: props.store.value === '' ? null : props.store.value,
    };

    return (
        <div className="row solicitorGroupList-wrapper">
            <div className="col-sm-12">
               
<CustomModal
isOpen={props.store.openModal}
handleClose={()=>props.changeSolicitorGroupListSettings('openModal',false)}
content= {<SolicitorGroupHOC />}
contentClassname={"solicitorGroupList-modal"}
/>

                <div className="row">
                    <h2 className="col-sm-12 applicationsAndPolicies-h2">{LEGAL_ADVICE_TEXT} Groups</h2>
                </div>
                <form className="form-horizontal" onSubmit={evt=>{evt.preventDefault(); props.handleAutosuggestButton()}}>
                    <div className="form-group">
                        <div className="col-md-2">
                            <label className={'control-label.text-left formGroupSelectInput-label'}>
                                {"Search"}
                            </label>
                        </div>
                        <div className="col-md-7 applicationsAndPolicies-autosuggest-wrapper">
                            <Autosuggest
                                suggestions={props.suggestions}
                                onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={props.onSuggestionsClearRequested}
                                getSuggestionValue={props.getSuggestionValue}
                                renderSuggestion={props.renderSuggestion}
                                inputProps={props.inputProps}
                                onSuggestionSelected={props.onSuggestionSelected}
                                theme ={{
                                    container: 'agents-list-action-autoSuggest-container',
                                    input:'applicationsAndPolicies-autosuggest',
                                    suggestionsContainer: 'applicationsAndPolicies-autosuggest-suggestionsContainer',
                                    suggestionsList: 'applicationsAndPolicies-autosuggest-suggestionsList',
                                    suggestion: 'applicationsAndPolicies-autosuggest-suggestion',
                                    suggestionHighlighted:'applicationsAndPolicies-autosuggest-suggestion-highLighted'
                                }}
                            />
                            <div className="applicationsAndPolicies-autosuggest-search-icon"
                                 onClick={props.handleAutosuggestButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                        <g id="info">
                                            <path
                                                d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <Button wrapper={"btn-wrapper"} clickHandler={() => props.changeSolicitorGroupListSettings('openModal', true)} btnType="button"  btnStyle={'btn btn-primary btn-xs sharp white'} label={`Create New ${LEGAL_ADVICE_TEXT} Group`}/>
                        </div>
                    </div>
                </form>
                {
                    (props.store.fetching && props.store.solicitorGroups.length === 0)?
                        <CenteredDots/>
                        :
                        props.store.solicitorGroups.length > 0?
                            <div>
                                <CustomTable
                                    accordionItemHeaderFormatter={(row) => (
                                        `Name: ${row.name} `
                                    )}
                                    onPageSizeChange={(evt) => {
                                        props.changeSolicitorGroupListSettings("selectedView",evt.target.value)
                                    }}
                                    goAtPage={props.changeSolicitorGroupListSettings}
                                    onPageShift={props.pageShift}
                                    loading={props.store.fetching}
                                    fixed
                                    responsive
                                    striped
                                    columns={columns}
                                    data={props.store.solicitorGroups}
                                    pageSize={parseInt(props.store.selectedView)}
                                    totalRecords={props.store.totalRecords}
                                    totalPages={props.store.totalBoxes}
                                    page={props.store.page}
                                    hasActions
                                    actions={[
                                        {
                                            key: 'details',
                                            label: 'Details',
                                            callback: (row) => props.changeSolicitorGroupListSettings('selectedGroup', row),
                                            handleRedirect: (row) => '/solicitors/solicitor-groups/edit-solicitor-group/' + row.id
                                        },
                                    ]}
                                    pageSizeOptions={TABLE_VIEW_OPTIONS}
                                />
                            </div>
                            :
                            <div className="text-center">
                                <span>No {LEGAL_ADVICE_TEXT.toLowerCase()} group to show.</span>
                            </div>
                }
            </div>
        </div>
    )
};

export default SolicitorGroupList;
